import { t as toLength$1 } from './to-length.js';

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

export { lengthOfArrayLike as l };
//# sourceMappingURL=length-of-array-like.js.map
